var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentsDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 2.08331C6.76043 2.08331 2.08334 6.7604 2.08334 12.5C2.08334 18.2396 6.76043 22.9166 12.5 22.9166C18.2396 22.9166 22.9167 18.2396 22.9167 12.5C22.9167 6.7604 18.2396 2.08331 12.5 2.08331ZM11.4583 10.4166V6.24998H13.5417V10.4166H16.6667L12.5 14.5833L8.33334 10.4166H11.4583ZM17.7083 17.7083H7.29168V15.625H17.7083V17.7083Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsDownload);
export default __webpack_public_path__ + "static/media/DocumentsDownload.fc2345da8cd36ba9f94b4795a817d0d3.svg";
export { ForwardRef as ReactComponent };